import templateOnly from '@ember/component/template-only';
import { concat } from '@ember/helper';
import isMobile from 'ember-is-mobile/helpers/is-mobile';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const UiKitButtonComponent = setComponentTemplate(precompileTemplate("\n  <button type=\"button\" class={{concat \"ui button !uppercase\" (if (isMobile \"any\") \"tiny\")}} ...attributes>\n    {{yield}}\n  </button>\n", {
  strictMode: true,
  scope: () => ({
    concat,
    isMobile
  })
}), templateOnly(undefined, "button:UiKitButtonComponent"));
export default UiKitButtonComponent;